<template>
  <default-dialog ref="dialog" close-button @hide="onDialogHide">
    <div class="column items-center">
      <img :src="require('@/assets/common/big-percentage.svg')"/>
      <div class="r-image-headline headline">איך זה מחושב?</div>
      <div class="r-regular-text column items-center content">
        <div class="r-text-regular paragraph">הכסף שהפקדת לקרן צובר ריבית וגדל</div>
        <r-icon class="text-riseup-blue" name="arrow_downward" size="30px"/>
        <div class="r-text-regular text-center paragraph">
          <div>כל שנה, הסכום הכולל שנצבר,</div>
          <div>צובר עוד ריבית, וגדל עוד יותר</div>
          <div>[ זה מה שנקרא ריבית דריבית ]</div>
        </div>
        <r-icon class="text-riseup-blue" name="arrow_downward" size="30px"/>
        <div class="r-text-regular">מהסכום הזה, מורידים את דמי הניהול </div>
        <div class="r-text-disclaimer text-center paragraph">
          <div>החישוב שמוצג הוא להמחשה בלבד, לפי 4% ריבית</div>
          <div>משוערת בניכוי דמי ניהול של {{ COMMISSION_IN_PERCENTAGE }}%</div>
        </div>
        <call-to-action-frame class="terms">
          <term term="קרן" explanation="כל הכסף שהפקדת"/>
          <term term="ריבית" explanation="היא הרווח או ההפסד" subtext="האפשריים בנק׳ זמן מסויימת. הגובה שלה תלוי
בביצועי הקופה" alternative-term="תשואה" />
          <term term="דמי ניהול" explanation="התשלום לבית ההשקעות"/>
        </call-to-action-frame>
      </div>
    </div>

  </default-dialog>
</template>

<script>
import DefaultDialog from '@/components/styled/DefaultDialog';
import GlobalDialog from '@/components/base/GlobalDialog';
import { COMMISSION_IN_PERCENTAGE } from '@/constants/meitav-dash/open-fund';
import CallToActionFrame from '@/components/styled/CallToActionFrame';
import Term from '@/components/meitav-dash/open-fund/Term';
import RIcon from '@/components/base/RIcon';

export default {
  name: 'ProjectionExplained',
  components: { RIcon, Term, CallToActionFrame, DefaultDialog },
  mixins: [GlobalDialog],
  computed: {
    COMMISSION_IN_PERCENTAGE() {
      return COMMISSION_IN_PERCENTAGE;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .paragraph {
    margin: 8px 0;
  }
}

.terms {
  margin-top: 24px;
  width: 100%;
}

.terms > div {
  margin-bottom: 8px;
}

.headline {
  margin-top: 20px;
}
</style>
